module.exports = __webpack_public_path__ + "static/media/61XaBy8t6uL.a0965459.jpg";